"use strict";

export function initInScope ($scope) {
    $scope.find('[data-toggle="popover"]').popover();
}
